import { ReactNode } from 'react'
import { FormControlLabel, Switch, SwitchProps } from '@mui/material'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

type SwitchInputControllerProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<SwitchProps, 'onBlur' | 'onChange' | 'value'> & {
    label?: ReactNode
  }

export default function SwitchInputController<T extends FieldValues>(props: SwitchInputControllerProps<T>) {
  const { control, label, name, readOnly, ...rest } = props
  const {
    field: { ref, value, onChange, ...otherFields },
  } = useController({ name, control })

  const switchComponent = <Switch {...rest} {...otherFields} onChange={!readOnly ? onChange : undefined} checked={value} readOnly={readOnly} />

  return label ? <FormControlLabel control={switchComponent} label={label} /> : switchComponent
}
